module.exports = __webpack_public_path__ + "img/prata.3e606b35.png";